// Formats the time from military time to 12-hour format e.g. '1700' to '5pm'
export const formatMilitaryTime = (militaryTime: string) => {
  // Extract hours and minutes from military time (e.g. '1700')
  let hours = parseInt(militaryTime.substring(0, 2))
  const minutesNumber = militaryTime.slice(-2)
  const minutes = minutesNumber === '00' ? '' : `${minutesNumber}`

  // Determine AM or PM
  const period = hours >= 12 ? 'pm' : 'am'

  // Convert to 12-hour format
  hours = hours % 12 || 12

  const colon = minutes ? ':' : ''

  // Return formatted time
  return `${hours}${colon}${minutes}${period}`
}
